import {Injectable} from '@angular/core';

@Injectable()
export class CommonConfig {

    static badgeRequestsImgAssets: string = '/assets/img/badge-requests';
    static employeeRequestReasonImgAssets: string = '/assets/img/employee-badge-request';
    static employeeMobileBadgeRequestReasonImgAssets: string = '/assets/img/mobile-badge-request';

    static exampleFileUrl: string = '/assets/files/Visitors template .xlsx';
    static disallowSpecialSymbolsExp: RegExp = /^[a-zA-Z0-9@ .,_-]+$/;

    static emailRegexp: RegExp =
        // tslint:disable-next-line
        /^\s*[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9]{2,})?\s*$/;

    public static urlRegexp: RegExp = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/; // tslint:disable-line

    static datesFormat = {
        full: 'MM/dd/yyyy, hh:mm a'
    };

    static cameraConfig = {
        width: 365,
        height: 365,
        defaultVideoAspectRatio: 1.8,
        defaultImageQuality: 0.9,
        defaultImageType: 'image/jpeg',
        maxPhotoFileSize: 10485760
    };

    static noPhotoUrl: string = '/assets/img/no_photo.svg';

    static fileUploadRestrictions = {
        photo: {
            title: 'Upload',
            button: 'Save',
            formats: ['JPG'],
            maxFileSize: 10 * 1024 * 1024, // 10 MB
            recommendedDimensions: {
                minWidth: 640,
                maxWidth: 640,
                minHeight: 800,
                maxHeight: 800,
                value: '640px * 800px',
                isImage: true,
            },
            isAttachment: false,
            isBulkVisitorUpload: false,
        },
        attachment: {
            title: 'Attachment',
            button: 'Add',
            formats: ['JPG', 'PDF', 'XLS', 'DOC', 'PPT', 'JPEG', 'PNG', 'ZIP','XLSX'],
            maxFileSize: 5 * 1024 * 1024, // 5 MB
            isAttachment: true,
            isBulkVisitorUpload: false,
        },
        bulkVisitorUpload: {
            title: 'Add visitor(s) from Excel',
            button: 'Add',
            formats: ['XLS', 'XLSX'],
            maxFileSize: 5 * 1024 * 1024, // 5 MB
            isAttachment: true,
            isBulkVisitorUpload: true,
        },
        bulkCleContractorUpload: {
            title: 'Add Contractor(s) from Excel',
            button: 'Add',
            formats: ['XLS', 'XLSX'],
            maxFileSize: 5 * 1024 * 1024, // 5 MB
            isAttachment: true,
            isCleUpload: true,
        }
    };
}
